module.exports = __webpack_public_path__ + "624c1255/img/41000000-9.baca48b3.png";